module.exports = __webpack_public_path__ + "static/media/prod15.d703a5f8.jpg";